import { apiRequest } from '@/api/client';
import type { DemoAuthResult, HubCategory, HubGame } from '@/types';

export async function fetchCategories(
  accessToken: string,
  sessionId?: string | null,
): Promise<HubCategory[]> {
  const data = await apiRequest<{ categories?: HubCategory[]; items?: HubCategory[] }>(
    '/library/categories',
    { accessToken, sessionId },
  );
  return data.categories ?? data.items ?? (Array.isArray(data) ? data : []);
}

export interface GamesQuery {
  category?: string;
  namePrefix?: string;
  limit?: number;
  offset?: number;
}

export async function fetchGames(
  accessToken: string,
  query: GamesQuery = {},
  sessionId?: string | null,
): Promise<HubGame[]> {
  const params = new URLSearchParams();
  if (query.category) params.set('category', query.category);
  if (query.namePrefix) params.set('namePrefix', query.namePrefix);
  if (query.limit) params.set('limit', String(query.limit));
  if (query.offset) params.set('offset', String(query.offset));

  const qs = params.toString();
  const data = await apiRequest<{ games?: HubGame[]; items?: HubGame[] }>(
    `/library/games${qs ? `?${qs}` : ''}`,
    { accessToken, sessionId },
  );
  return data.games ?? data.items ?? (Array.isArray(data) ? data : []);
}

export async function fetchGame(
  id: string,
  accessToken: string,
  sessionId?: string | null,
): Promise<HubGame> {
  const data = await apiRequest<{ game?: HubGame } & HubGame>(
    `/library/games/${encodeURIComponent(id)}`,
    { accessToken, sessionId },
  );
  return data.game ?? data;
}

export interface DemoLaunchOptions {
  currency?: string;
  language?: string;
}

export async function authenticateDemo(
  id: string,
  accessToken: string,
  sessionId?: string | null,
  options: DemoLaunchOptions = {},
): Promise<DemoAuthResult> {
  return apiRequest<DemoAuthResult>(
    `/library/games/${encodeURIComponent(id)}/demo/authenticate`,
    { method: 'POST', accessToken, sessionId, body: options },
  );
}
